import { UserRole } from '../types/User';

export const isAdmin = (userRole?: UserRole): boolean => {
  return ['superadmin', 'admin'].includes(userRole || '');
};
